export default "__VITE_ASSET__C4CAnwtq__"